import { create } from 'zustand';

const useActiveObjectId = create(set => ({
  activeObjectId: null,
  setActiveObjectId: activeObjectId => set({ activeObjectId }),
}));

export default useActiveObjectId;